import { DownloadDraftParams } from 'app/dataTypes/cafeteria/compensation/withdraw/toParent/draft'

import type { Request } from '../../../../index'


type ParamsApi = {
  withdraw_order_id: number
}

export const convertParams = ({
  withdrawID,
}: DownloadDraftParams): [ParamsApi, null] => {
  return [{
    withdraw_order_id: parseInt(withdrawID, 10),
  }, null]
}


export const GET_COMPENSATION_WITHDRAW_ORDERS_DOWNLOAD: Request<DownloadDraftParams, void, void> = [
  'cabinet/compensation/withdraw_orders/download',
  'get',
  [],
]
